export const REPORTING_FEATURE_KEY = "page.reporting";

export const REPORTING_ROUTES = {
  punchClock: "/report/punch-clock",
  shiftplan: "/report/shiftplan",
};

function parseFeatureConfig(value) {
  if (Array.isArray(value)) return value;
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function optionEnabled(config, optionName) {
  const option = config.find((item) => item?.name === optionName);
  return option?.enabled !== false;
}

export function getReportingAvailability(features, punchClockEnabled = false) {
  const featureRows = Array.isArray(features) ? features : [];
  const reportingFeature = featureRows.find(
    (feature) => feature?.feature_key === REPORTING_FEATURE_KEY
  );
  const reportingConfig = parseFeatureConfig(reportingFeature?.config_json);
  return {
    punchClock: Boolean(punchClockEnabled),
    shiftplan: optionEnabled(reportingConfig, "reporting_shiftplan"),
  };
}

export function getDefaultReportingRoute(features, punchClockEnabled = false) {
  const availability = getReportingAvailability(features, punchClockEnabled);
  if (availability.punchClock) return REPORTING_ROUTES.punchClock;
  if (availability.shiftplan) return REPORTING_ROUTES.shiftplan;
  return null;
}
